import React from 'react';
import Header from '../../../components/Header';
import ComponentHeader from '../../../components/ComponentHeader';
import ReportTable from './ReportTable';

const Reports = () => {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Report'} />
      <div className="flex-1 overflow-auto">
        <div className="flex justify-end mb-4">
          <ComponentHeader />
        </div>
        <ReportTable />
      </div>
    </div>
  );
};

export default Reports;
